module.exports = __webpack_public_path__ + "static/media/fishbowl.29c01e67.png";